export default "__VITE_ASSET__CLbo2jBp__"